import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons'
import { Button, Modal, Select, Tooltip, message } from 'antd'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { fetchGroupList } from '../../apis/group'
import { deleteTaxonomy, fetchTaxonomyTree } from '../../apis/taxonomy'
import MainTable from '../../components/Basic/MainTable'
import useParams from '../../hook/useParams'
import { MenuWrapper, WhiteWrapper } from './taxonomy.styled'
import TaxonomyModal from './Modal'

function Taxonomy (props) {
  const { adminMode } = props
  const { t: ln_t } = useTranslation()
  const user = useSelector((state) => state.user)
  const { nowGroup } = user
  const params = useParams()
  const { fetchParams, handleFetchParams } = params
  const [formMode, setFormMode] = useState('')
  const [openModal, setOpenModal] = useState(false)
  const [taxonomyData, setTaxonomyData] = useState({})
  const [groupsOption, setGroupsOption] = useState([])
  const [groupId, setGroupId] = useState(nowGroup)
  const [parent, setParent] = useState([])

  const apiFunc = async () => fetchTaxonomyTree(groupId, fetchParams)?.then(res => {
    if (res?.status === 200) setParent(res?.data?.map(i => i.id))
    return res
  })

  const handleAddParentTaxonomy = () => {
    setOpenModal(true)
    setFormMode('add')
  }

  const handleAddChildTaxonomy = (record) => {
    setOpenModal(true)
    setFormMode('addChildTaxonomy')
    setTaxonomyData(record)
  }

  const handleEdit = (record) => {
    setOpenModal(true)
    setFormMode('edit')
    setTaxonomyData(record)
  }

  const handleDelete = (record) => {
    const { id, name } = record
    Modal.confirm({
      title: `${ln_t('util.delete')} ${ln_t('sidebar.taxonomy')}`,
      content: `${ln_t('message.confirm.delete')} ${name} ?`,
      onOk: async () => {
        const result = await deleteTaxonomy(id)
        if (result?.status === 204) {
          message.success(ln_t('message.success.delete'))
          handleFetchParams('add', {})
        }
      }
    })
  }

  const columns = [
    { title: ln_t('util.name'), dataIndex: 'name' },
    { title: ln_t('util.status'), dataIndex: 'status', render: e => e === 1 ? ln_t('util.enable') : ln_t('util.disable') },
    { title: ln_t('util.createdAt'), dataIndex: 'createdAt', render: (e, record) => dayjs(e).format('YYYY-MM-DD') },
    { title: ln_t('util.updatedAt'), dataIndex: 'updatedAt', render: (time) => dayjs(time).format('YYYY-MM-DD hh:mm') },
    ...adminMode
      ? []
      : [{
          title: ln_t('util.action'),
          dataIndex: 'id',
          render: (id, record) => (
            <div className="action-btn">
              {record.parentId === 0 || parent.includes(record.parentId)
                ? <Tooltip title={`${ln_t('util.add')} ${ln_t('taxonomy.taxonomy')}`}>
                    <Button size="small" icon={<PlusOutlined />} onClick={() => handleAddChildTaxonomy(record)} />
                  </Tooltip>
                : ''}
              <Button size="small" icon={<EditOutlined />} onClick={() => handleEdit(record)}/>
              <Button size="small" icon={<DeleteOutlined />} onClick={() => handleDelete(record)} />
            </div>
          )
        }]
  ]

  const getGroups = async () => {
    const result = await fetchGroupList({ maxResults: 1000, sort: '-updatedAt' })
    if (result?.status === 200) {
      setGroupsOption(result?.data?.map(i => ({ value: i?.id, label: i?.name })))
      setGroupId(result?.data?.[0]?.id)
    }
  }
  useEffect(() => { if (adminMode) getGroups() }, [])
  useEffect(() => handleFetchParams('add', {}), [groupId])

  return (
    <>
      <WhiteWrapper>
        <h3>{ln_t('sidebar.taxonomy')}</h3>
        <MenuWrapper>
          {adminMode
            ? <div>
                <span style={{ fontSize: '14px', fontWeight: 500, marginRight: '8px' }}>{ln_t('util.group')} :</span>
                <Select
                  value={groupId}
                  style={{ minWidth: '150px' }}
                  placeholder="Select a group"
                  optionFilterProp="children"
                  onChange={(e) => setGroupId(e)}
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  options={groupsOption}
                />
              </div>
            : <Button type="default" icon={<PlusOutlined />} onClick={handleAddParentTaxonomy} >{ln_t('util.add')} {ln_t('sidebar.taxonomy')}</Button>}
        </MenuWrapper>
        <MainTable
          columns={columns}
          rowKey="id"
          apiFunc={apiFunc}
          params={params}
        />
      </WhiteWrapper>

      {/* --- Taxonomy Modal --- */}
      <TaxonomyModal
        openModal={openModal}
        setOpenModal={setOpenModal}
        formMode={formMode}
        setFormMode={setFormMode}
        handleFetchParams={handleFetchParams}
        taxonomyData={taxonomyData}
        setTaxonomyData={setTaxonomyData}
        groupId={groupId}
      />
    </>
  )
}

export default Taxonomy
